import { action } from 'mobx';
import { container, singleton } from 'tsyringe';

import { CookiesStore } from '../stores/cookie';
@singleton()
export class CookiesStoreFacade {
  originalStore: CookiesStore;

  constructor() {
    this.originalStore = container.resolve(CookiesStore);
  }

  public get cookieAccepted() {
    return this.originalStore.cookieAccepted;
  }

  public checkCookieConfirmation() {
    return this.originalStore.checkCookieConfirmation();
  }

  public get cookiePolicyUrl() {
    return this.originalStore.cookiePolicyUrl;
  }

  /**
   * @argument userAgent: window.navigator.userAgent
   */
  @action.bound
  public acceptCookiePromt(userAgent: string) {
    return this.originalStore.acceptCookiePromt(userAgent);
  }
}
